import { useTranslation } from 'react-i18next';
import { dateFormatEn, dateFormatJa } from '../constants/dateFormat';
import { LanguagesEnum } from '../../types/Languages';
export function useGetDateFormat() {
    const { i18n } = useTranslation();
    const dateFormat = LanguagesEnum.JP.includes(i18n.language) ? dateFormatJa : dateFormatEn;
    return dateFormat;
}
